import { EntityType, OverriddenNegotiationSide } from 'api'
import { BTQAction } from 'epics'

import { Observable, concatMap, from } from 'rxjs'

import { ofEntityUpdateType } from './epicUtils'
import { RepositoryActions } from 'store/repository'
import { SHOULD_AUTOBATCH } from '@reduxjs/toolkit'

export function negotiationOverrideEpic(action$: Observable<BTQAction>): Observable<BTQAction> {
  return action$.pipe(
    ofEntityUpdateType(EntityType.NEGOTIATION_OVERRIDE),
    concatMap(({ entity: { negotiationId, overriddenSide } }) =>
      from([
        RepositoryActions.revertUpdates(EntityType.NEGOTIATION, negotiationId, {
          ownOrder: overriddenSide === OverriddenNegotiationSide.INITIATOR,
          [SHOULD_AUTOBATCH]: true
        }),
        ...(overriddenSide === OverriddenNegotiationSide.BOTH
          ? [
              RepositoryActions.revertUpdates(EntityType.NEGOTIATION, negotiationId, {
                ownOrder: true,
                [SHOULD_AUTOBATCH]: true
              })
            ]
          : [])
      ])
    )
  )
}
